export type Maybe<T> = T | null | undefined;

export function mapMaybe<T, R>(maybe: Maybe<T>, fn: (v: T) => R) {
  return maybe === undefined ? undefined : maybe === null ? null : fn(maybe);
}
